import L from 'leaflet';

import { Coordinate } from "./coordinate";
import { ILeafletObject } from "../common/index";

import { environment } from '../../environments/environment';

export class RailPoint {
    coordinate: Coordinate;
    stopId?: number;
}

export class Rail {
    id: number;
    points: RailPoint[];
}

export class LeafletRail extends Rail implements ILeafletObject {
    private defaultOptions: any;
    private selectionOptions: any;

    // polylineBackground: L.Polyline;
    polyline: L.Polyline;

    isSelected: boolean = false;

    constructor(rail: Rail) {
        super();

        this.id = rail.id;
        this.points = rail.points;

        if (environment.map && environment.map.rail && environment.map.rail.style) {
            this.defaultOptions = environment.map.rail.style.default;
            this.selectionOptions = environment.map.rail.style.selected;

            this.polyline = L.polyline(rail.points.map(p => [p.coordinate.latitude, p.coordinate.longitude]), this.defaultOptions);
        }
    }

    select() {
        if (this.selectionOptions)
            this.polyline.setStyle(this.selectionOptions);
        this.isSelected = true;
    }

    unselect() {
        if (this.defaultOptions)
            this.polyline.setStyle(this.defaultOptions);
        this.isSelected = false;
    }

    enable() {
        let el = this.polyline.getElement();
        L.DomUtil.removeClass(el, 'disabled-map-object');
        // let elBackground = this.polylineBackground.getElement();
        // L.DomUtil.removeClass(elBackground, 'disabled-map-object');
    }

    disable() {
        let el = this.polyline.getElement();
        L.DomUtil.addClass(el, 'disabled-map-object');
        // let elBackground = this.polylineBackground.getElement();
        // L.DomUtil.addClass(elBackground, 'disabled-map-object');
    }
}

export class SegmentedLeafletRail {
    private defaultOptions: any;
    private selectionOptions: any;
    private _points: RailPoint[];

    private _polyline: L.Polyline;
    get polyline(): L.Polyline {
        return this._polyline
    }

    constructor(points: RailPoint[]) {
        this._points = points;

        if (environment.map && environment.map.rail && environment.map.rail.style) {
            this.defaultOptions = environment.map.rail.style.default;
            this.selectionOptions = environment.map.rail.style.selected;

            this._polyline = L.polyline(points.map(p => [p.coordinate.latitude, p.coordinate.longitude]), this.selectionOptions);
        }
    }
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/core/rail.ts